// app/javascript/channels/chat_channel.js
import consumer from "./consumer"


consumer.subscriptions.create({channel: "UserChannel"}, {
    connected() {
        console.log("UserChannel:: connected");
    },
    received(data) {
        const eventAwesome = new CustomEvent("notification:show", {
            bubbles: true,
            detail: {text: () => data},
        });
        console.log("channel::user", JSON.stringify(data));
    }
})


// app/javascript/channels/appearance_channel.js